import { WifiOff } from 'lucide-react'
import useOnlineStatus from '../lib/useOnlineStatus'

export default function OfflineBanner() {
  const isOnline = useOnlineStatus()
  if (isOnline) return null

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-red-900 border-t border-red-700 px-4 py-2 flex items-center justify-center gap-2 text-sm text-red-200 font-medium">
      <WifiOff size={14} />
      <span>Offline — actions won't be saved until you reconnect</span>
    </div>
  )
}